import { render } from "./Archive.vue?vue&type=template&id=071ffbc0&scoped=true&bindings={\"loading\":\"setup\",\"topics\":\"setup\",\"categories\":\"setup\",\"filterTypes\":\"setup\",\"selectTopic\":\"setup\",\"selectedTopic\":\"setup\",\"selectCategory\":\"setup\",\"selectedCategory\":\"setup\",\"selectFilterType\":\"setup\",\"selectedFilterType\":\"setup\",\"archives\":\"setup\",\"totalPages\":\"setup\"}"
import script from "./Archive.vue?vue&type=script&lang=ts"
export * from "./Archive.vue?vue&type=script&lang=ts"

import "./Archive.vue?vue&type=style&index=0&id=071ffbc0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-071ffbc0"

export default script